export default {
  env: process.env.VUE_APP_NODE_ENV === 'production' ? 'prod' : 'dev', // dev, stage, prod
  steps: {},
  schemaIds: {
    PersonhoodCredential: {
      schemaId: 'sch:hid:testnet:z6MkmS1CuEGST6FjcR1ojtM1rcmVcNXG31bFXGCcehx2WXMh:1.0',
      issuer: 'did:hid:testnet:zCyAz2wfKjAaWE4FW75KxpZh2wuo9kRAUZyV2xEe93cKr',
    },
    PassportCredential: {
      schemaId: 'sch:hid:testnet:z6MkgMXXQL7YD7BufNLbjrwueoj4nmih9xujJ6aozJDmzFWx:1.0',
      issuer: 'did:hid:testnet:zCyAz2wfKjAaWE4FW75KxpZh2wuo9kRAUZyV2xEe93cKr',
    },
    SBTCredential: {
      schemaId: 'sch:hid:testnet:z6MkgHqTUpPtkXJ9dAMt25WQB5MHmC1qqc74z7q2fZk2kPQP:1.0',
      issuer: 'did:hid:testnet:zCyAz2wfKjAaWE4FW75KxpZh2wuo9kRAUZyV2xEe93cKr',
    },
    GovernmentIdCredential: {},
    zkProofOfKYC: {},
    zkProofOfAge: {},
    zkProofOfPersonHood: {},
  },
  licenseKey: {
    // expires 15/01/2026
    // domain: verify.hypersign.id
    prod: process.env.VUE_APP_FACEPHI_WIDGET_PROD,
    // expires: never
    // domain: localhost
    dev: process.env.VUE_APP_FACEPHI_WIDGET_DEV,
  },
}
